import React, { useState, useEffect } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { apiService } from '../services/apiService'
import toast from 'react-hot-toast'

const SystemSettingForm = ({ systemSetting, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    key_name: '',
    value: '',
    category: 'general',
    description: '',
    editable: true
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (systemSetting) {
      setFormData({
        key_name: systemSetting.key_name || '',
        value: systemSetting.value || '',
        category: systemSetting.category || 'general',
        description: systemSetting.description || '',
        editable: systemSetting.editable !== false
      })
    }
  }, [systemSetting])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      let result
      if (systemSetting) {
        result = await apiService.updateSystemSetting(systemSetting.id, formData)
      } else {
        result = await apiService.createSystemSetting(formData)
      }

      toast.success(
        systemSetting
          ? 'Configuração atualizada com sucesso!'
          : 'Configuração criada com sucesso!'
      )
      onSuccess()
    } catch (error) {
      console.error('Erro ao salvar configuração:', error)
      toast.error('Erro ao salvar configuração')
    } finally {
      setLoading(false)
    }
  }

  const categories = [
    { value: 'general', label: 'Geral' },
    { value: 'financial', label: 'Financeiro' },
    { value: 'notifications', label: 'Notificações' },
    { value: 'maintenance', label: 'Manutenção' }
  ]

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            {systemSetting ? 'Editar Configuração' : 'Nova Configuração'}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Chave *
              </label>
              <input
                type="text"
                name="key_name"
                value={formData.key_name}
                onChange={handleChange}
                required
                disabled={systemSetting} // Não permite editar chave de configuração existente
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white font-mono disabled:bg-gray-100 disabled:text-gray-500"
                placeholder="Ex: company_name, max_vehicles"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Categoria *
              </label>
              <select
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
              >
                {categories.map(category => (
                  <option key={category.value} value={category.value}>
                    {category.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Valor *
            </label>
            <input
              type="text"
              name="value"
              value={formData.value}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
              placeholder="Valor da configuração"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Descrição
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
              placeholder="Descrição da configuração..."
            />
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              name="editable"
              id="editable"
              checked={formData.editable}
              onChange={handleChange}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="editable" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
              Configuração editável pelos usuários
            </label>
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 disabled:opacity-50 transition-colors"
            >
              {loading ? 'Salvando...' : systemSetting ? 'Atualizar' : 'Criar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SystemSettingForm